// extracted by mini-css-extract-plugin
export default {"header":"header_header__PUAOw","link":"header_link__bc-bS","glow":"header_glow__l-nkk"};